export class WbAnchorList {
  constructor() {}

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;

    document.querySelectorAll('.wb-anchor-list__toggle').forEach(button => {
      button.addEventListener('click', _this.toggleList.bind(_this));
    });
  }

  toggleList(e) {
    const target = e.currentTarget;
    const parent = target.closest('.wb-anchor-list');

    target._toggleAriaExpanded();
    parent.querySelector('.wb-anchor-list__nav')._slideToggle();
  }
}
